import {
	STORE_LIST_REQUESTING,
	STORE_LIST_SUCCESS,
	STORE_LIST_ERROR,
	STORE_DETAIL_REQUESTING,
	STORE_DETAIL_SUCCESS,
	STORE_DETAIL_ERROR,
	UPDATE_STORE_REQUESTING,
	UPDATE_STORE_SUCCESS,
	UPDATE_STORE_ERROR,
	SET_FILTER,
	OTP_REQUESTING,
	OTP_REQUESTING_SUCCESS,
	OTP_REQUESTING_ERROR,
	VERIFY_OTP_REQUESTING,
	VERIFY_OTP_SUCCESS,
	VERIFY_OTP_ERROR,
	IMAGE_UPDATE_LOADER_TRUE,
	IMAGE_UPDATE_LOADER_FALSE,
	RESET_MANAGE_STORES,
	SEARCH_MORE_STORE_SUCCESS,
	TOTAL_STORE_LIST_REQUESTING,
} from './types';

export const initialState = {
	storeList: {
		isLoading: false,
		error: undefined,
		data: {},
		totalStore: [],
		totalStoreLoading: false,
	},
	storeDetail: { isLoading: false, error: undefined, data: {} },
	imageUpdateLoading: false,
	getOtp: { loading: false, otp: false, data: {} },
	verifyOtp: { verified: false },
	pageNo: 1,
	pageSize: 20,
	merchantId: '',
};

function initApp(state = initialState, action) {
	switch (action.type) {
		case SET_FILTER:
			return {
				...state,
				pageNo: action.payload.pageNo,
				pageSize: action.payload.pageSize,
				merchantId: action.payload.merchantId,
			};
		case STORE_LIST_REQUESTING:
			return {
				...state,
				storeList: {
					...state.storeList,
					isLoading: true,
					error: undefined,
					totalStore: [],
				},
			};
		case STORE_LIST_SUCCESS:
			return {
				...state,
				storeList: {
					...state.storeList,
					isLoading: false,
					data: action.data,
					error: undefined,
					totalStore: action.data.storeDetailResponses, // infinite scroll case
				},
			};
		case TOTAL_STORE_LIST_REQUESTING:
			return {
				...state,
				storeList: {
					...state.storeList,
					totalStoreLoading: true,
					isLoading: false,
					error: undefined,
				},
			};
		case SEARCH_MORE_STORE_SUCCESS:
			return {
				...state,
				storeList: {
					...state.storeList,
					totalStoreLoading: false,
					isLoading: false,
					data: action.data,
					totalStore: [
						...state.storeList.totalStore,
						...action.data.storeDetailResponses,
					],
					error: undefined,
				},
			};
		case STORE_LIST_ERROR:
			return {
				...state,
				storeList: {
					...state.storeList,
					totalStoreLoading: false,
					isLoading: false,
					error: action.error,
				},
			};
		case STORE_DETAIL_REQUESTING:
		case UPDATE_STORE_REQUESTING:
			return {
				...state,
				storeDetail: {
					...state.storeDetail,
					isLoading: true,
					error: undefined,
				},
			};
		case STORE_DETAIL_SUCCESS:
			return {
				...state,
				storeDetail: {
					isLoading: false,
					data: action.data,
					error: undefined,
				},
			};
		case STORE_DETAIL_ERROR:
		case UPDATE_STORE_ERROR:
			return {
				...state,
				storeDetail: {
					...state.storeDetail,
					isLoading: false,
					error: action.error,
				},
			};
		case UPDATE_STORE_SUCCESS:
			return {
				...state,
				storeDetail: {
					...state.storeDetail,
					isLoading: false,
				},
			};
		case OTP_REQUESTING:
			return {
				...state,
				getOtp: { ...state.getOtp, loading: true, data: {} },
			};
		case OTP_REQUESTING_SUCCESS:
			return {
				...state,
				getOtp: { loading: false, otp: true, data: action.data },
			};
		case OTP_REQUESTING_ERROR:
			return {
				...state,
				getOtp: { loading: false, otp: false },
			};
		case VERIFY_OTP_REQUESTING:
			return {
				...state,
				storeDetail: {
					...state.storeDetail,
					isLoading: true,
					error: undefined,
				},
				verifyOtp: {
					verified: false,
				},
			};
		case VERIFY_OTP_SUCCESS:
			return {
				...state,
				storeDetail: {
					...state.storeDetail,
					isLoading: false,
				},
				verifyOtp: { verified: true },
			};
		case VERIFY_OTP_ERROR:
			return {
				...state,
				storeDetail: {
					...state.storeDetail,
					isLoading: false,
				},
				verifyOtp: { verified: false },
			};
		case IMAGE_UPDATE_LOADER_TRUE:
			return {
				...state,
				imageUpdateLoading: true,
			};
		case IMAGE_UPDATE_LOADER_FALSE:
			return {
				...state,
				imageUpdateLoading: false,
			};
		case RESET_MANAGE_STORES:
			return initialState;
		default:
			return state;
	}
}

export default initApp;
